import type { Receipt, ReceiptCategory } from '../types';

/** Categories shown under Travel documents (tickets, passes, taxi/ride). */
export const TRAVEL_DOCUMENT_CATEGORIES: readonly ReceiptCategory[] = [
  'flight',
  'train',
  'bus',
  'ferry',
  'transport',
] as const;

export function isTravelDocumentReceipt(r: Receipt): boolean {
  return (TRAVEL_DOCUMENT_CATEGORIES as readonly string[]).includes(r.category);
}
